import { render, staticRenderFns } from "./SortListIcon.vue?vue&type=template&id=15d052a8&"
import script from "./SortListIcon.vue?vue&type=script&lang=js&"
export * from "./SortListIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports